// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mockup-preview-video[data-v-4f6b2357]{position:relative;display:flex;align-items:center;justify-content:center;background-color:#6495ed;flex:none;margin-bottom:6px;border-radius:5px}.mockup-preview-video video[data-v-4f6b2357]{width:inherit}", ""]);
// Exports
module.exports = exports;
